// extracted by mini-css-extract-plugin
export default {"header":"lmPzBT","cards":"QdwjMy","logo":"fBYPBe"};